import React from 'react';
import { varCoolgray200 } from '../../helpers/chartColors';
import DonutChart from '../DonutChart';
import { backgroundColors } from './utils';

interface ChartProps {
  id: string;
  data?: any;
  label: string;
  value: string;
  colors: string[];
  children?: React.ReactNode;
}

const Chart: React.FC<ChartProps> = ({ id, data, label, value, colors, children }) => {
  let disableTooltips = false;
  const labels = data.map((r: any) => r[label]);
  const values = data.map((r: any) => r[value]);

  const chartData = {
    labels: labels,
    datasets: [
      {
        label: 'responses',
        data: values,
        backgroundColor: backgroundColors(colors, values),
        borderWidth: 0,
      },
    ],
  };

  // setup empty ring if all values are 0
  chartData.datasets.forEach(dataset => {
    if (dataset.data.every((el: number) => el === 0)) {
      dataset.backgroundColor.push(varCoolgray200);
      dataset.data.push(1);
      disableTooltips = true;
    }
  });

  return (
    <DonutChart id={id} data={chartData} disableTooltips={disableTooltips}>
      {children}
    </DonutChart>
  );
};

export default Chart;
